export const categoryType = {
	ASSETS: 1,
	DEVICES: 2,
	BOOKABLE_RESOURCES: 3
};
